
export const GET_PHYSICIAN = 'GET_GET_PHYSICIAN'
export const GET_PHYSICIAN_REQUEST = 'GET_PHYSICIAN_REQUEST'
export const GET_PHYSICIAN_SUCCESS = 'GET_PHYSICIAN_SUCCESS'
export const GET_PHYSICIAN_FAILURE = 'GET_PHYSICIAN_FAILURE'


export const getPhysicianRequest = payload => ({ type: GET_PHYSICIAN_REQUEST, payload })
export const getPhysicianSuccess = payload => ({ type: GET_PHYSICIAN_SUCCESS, payload })
export const getPhysicianFailure = (error) => ({ type: GET_PHYSICIAN_FAILURE, payload: error })


export const POST_PHYSICIANS = 'POST_PHYSICIANS'
export const POST_PHYSICIANS_REQUEST = 'POST_PHYSICIANS_REQUEST'
export const POST_PHYSICIANS_SUCCESS = 'POST_PHYSICIANS_SUCCESS'
export const POST_PHYSICIANS_FAILURE = 'POST_PHYSICIANS_FAILURE'

export const GET_CHECK_GROUP = 'GET_CHECK_GROUP'
export const GET_CHECK_GROUP_REQUEST = 'GET_CHECK_GROUP_REQUEST'
export const GET_CHECK_GROUP_SUCCESS = 'GET_CHECK_GROUP_SUCCESS'
export const GET_CHECK_GROUP_FAILURE = 'GET_CHECK_GROUP_FAILURE'

export const getCheckGroupFailure = (data) => { return ({ type: GET_CHECK_GROUP_FAILURE, data }) }

export const getCheckGroupRequest = (payload) => ({ type: GET_CHECK_GROUP_REQUEST, payload })

export const getCheckGroupSuccess = (data) => { return ({ type: GET_CHECK_GROUP_SUCCESS, data }) }

export const postPhysiciansRequest = (payload) => ({ type: POST_PHYSICIANS_REQUEST, payload })
export const postPhysiciansSuccess = (data) => ({ type: POST_PHYSICIANS_SUCCESS, data })
export const postPhysiciansFailure = (error) => ({ type: POST_PHYSICIANS_FAILURE, payload: error })

export const PATCH_AFFILIATED_GROUP = 'PATCH_AFFILIATED_GROUP'
export const PATCH_AFFILIATED_GROUP_REQUEST = 'PATCH_AFFILIATED_GROUP_REQUEST'
export const PATCH_AFFILIATED_GROUP_SUCCESS = 'PATCH_AFFILIATED_GROUP_SUCCESS'
export const PATCH_AFFILIATED_GROUP_FAILURE = 'PATCH_AFFILIATED_GROUP_FAILURE'

export const patchAffiliatedGroupRequest = (payload) => ({ type: PATCH_AFFILIATED_GROUP_REQUEST, payload })
export const patchAffiliatedGroupSuccess = (data) => {
  return ({ type: PATCH_AFFILIATED_GROUP_SUCCESS, data })
}


export const GET_EXTERNAL_PHYSICIANS = 'GET_EXTERNAL_PHYSICIANS'
export const GET_EXTERNAL_PHYSICIANS_REQUEST = 'GET_EXTERNAL_PHYSICIANS_REQUEST'
export const GET_EXTERNAL_PHYSICIANS_SUCCESS = 'GET_EXTERNAL_PHYSICIANS_SUCCESS'
export const GET_EXTERNAL_PHYSICIANS_FAILURE = 'GET_EXTERNAL_PHYSICIANS_FAILURE'

export const getExternalPhysiciansRequest = () => ({ type: GET_EXTERNAL_PHYSICIANS_REQUEST })
export const getExternalPhysiciansSuccess = (data) => ({ type: GET_EXTERNAL_PHYSICIANS_SUCCESS, data })
export const getExternalPhysiciansFailure = (error) => ({ type: GET_EXTERNAL_PHYSICIANS_FAILURE, payload: error })

export const GET_INTERNAL_PHYSICIANS = 'GET_INTERNAL_PHYSICIANS'
export const GET_INTERNAL_PHYSICIANS_REQUEST = 'GET_INTERNAL_PHYSICIANS_REQUEST'
export const GET_INTERNAL_PHYSICIANS_SUCCESS = 'GET_INTERNAL_PHYSICIANS_SUCCESS'
export const GET_INTERNAL_PHYSICIANS_FAILURE = 'GET_INTERNAL_PHYSICIANS_FAILURE'

export const getInternalPhysiciansRequest = () => ({ type: GET_INTERNAL_PHYSICIANS_REQUEST })
export const getInternalPhysiciansSuccess = (data) => ({ type: GET_INTERNAL_PHYSICIANS_SUCCESS, data })
export const getInternalPhysiciansFailure = (error) => ({ type: GET_INTERNAL_PHYSICIANS_FAILURE, payload: error })